import { render } from "./SolucaoModalHistorico.vue?vue&type=template&id=6d99a652"
import script from "./SolucaoModalHistorico.vue?vue&type=script&lang=js"
export * from "./SolucaoModalHistorico.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__